document.addEventListener('DOMContentLoaded', function() {
  const year = new Date().getFullYear();
  
  document.querySelector('.copyright-year').textContent = year;

  // ── Acordeón FAQ ──
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var answer = item.querySelector('.faq-answer');
      var isOpen = item.classList.contains('open');

      // Cerrar todos
      document.querySelectorAll('.faq-item.open').forEach(function (el) {
        el.classList.remove('open');
        el.querySelector('.faq-answer').classList.remove('open');
      });

      // Abrir el clickeado si estaba cerrado
      if (!isOpen) {
        item.classList.add('open');
        answer.classList.add('open');
      }
    });
  });

  // ── Filtros por categoría ──
  document.querySelectorAll('.filter-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var cat = btn.getAttribute('data-filter');

      document.querySelectorAll('.filter-btn').forEach(function (b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');

      document.querySelectorAll('.faq-item').forEach(function (item) {
        item.style.display = (cat === 'all' || item.getAttribute('data-cat') === cat) ? 'block' : 'none';
      });

      document.querySelectorAll('.section-header').forEach(function (sec) {
        sec.style.display = (cat === 'all' || sec.getAttribute('data-section') === cat) ? 'flex' : 'none';
      });
    });
  });

  const mobileImages = [
    'https://cdn.shopify.com/s/files/1/0732/5007/8889/files/1v_1.png?v=1774537102', // slide 0
    'https://cdn.shopify.com/s/files/1/0732/5007/8889/files/2v.png?v=1774556688', // slide 1
    'https://cdn.shopify.com/s/files/1/0732/5007/8889/files/3v.png?v=1774556688',
  ];

  const BREAKPOINT = 750; // mismo breakpoint que usa tu tema (ver sizes en srcset)

  function swapToMobile() {
    if (window.innerWidth >= BREAKPOINT) return; // solo mobile, desktop no toca nada

    document.querySelectorAll('.slideshow-section .slide__image-container img.slide__image')
      .forEach((img, index) => {
        const mobileUrl = mobileImages[index];
        if (!mobileUrl) return;

        img.removeAttribute('srcset'); // neutraliza el srcset responsive
        img.removeAttribute('sizes');
        img.src = mobileUrl;
      });
  }

  swapToMobile();
});

if (window.location.pathname === '/pages/enlaces') {
  document.querySelector('.section-title').style.display = 'none'
  document.querySelector('.section-divider').style.display = 'none'
}

